import { logger, logError } from '@digiwedge/logger';
/**
 * Validates presence of all required environment variables.
 * Throws an error listing any missing variables.
 * @returns Object containing the validated variables
 */
export function validateEnv() {
    // Skip validation when running in environments without `process`
    // (e.g. Storybook or browser tests)
    if (typeof process === 'undefined' || !process.env) {
        return {
            AXIZ_DIGITAL_API: '',
            AXIZ_DIGITAL_IDENT: '',
            AXIZ_CLIENT_ID: '',
            AXIZ_CLIENT_SECRET: '',
            AXIZ_SCOPE: '',
        };
    }
    const missing = [];
    const pick = (...keys) => {
        for (const k of keys) {
            const v = process.env[k];
            if (v && v.trim().length > 0)
                return v;
        }
        return undefined;
    };
    const base = pick('AXIZ_DIGITAL_API');
    const token = pick('AXIZ_DIGITAL_IDENT');
    const clientId = pick('AXIZ_CLIENT_ID');
    const clientSecret = pick('AXIZ_CLIENT_SECRET', 'AXIZ_CLIENT_ID_SECRET');
    const scope = pick('AXIZ_SCOPE') || '';
    if (!base)
        missing.push('AXIZ_DIGITAL_API');
    if (!token)
        missing.push('AXIZ_DIGITAL_IDENT');
    if (!clientId)
        missing.push('AXIZ_CLIENT_ID');
    if (!clientSecret)
        missing.push('AXIZ_CLIENT_SECRET');
    if (missing.length) {
        logError(logger, 'Missing required environment variables', { missing });
        throw new Error(`Missing required environment variables: ${missing.join(', ')}`);
    }
    return {
        AXIZ_DIGITAL_API: base,
        AXIZ_DIGITAL_IDENT: token,
        AXIZ_CLIENT_ID: clientId,
        AXIZ_CLIENT_SECRET: clientSecret,
        AXIZ_SCOPE: scope,
    };
}
//# sourceMappingURL=validateEnv.js.map